export default __webpack_public_path__ + "static-front/media/QrCode.7fcc76f7.svg";